import { VisualizationType, EditableComponent } from '../../models';
import { VisualizationTypeStrategy } from '../models';
import RatioBarEditor from './RatioBar.json';
import { RatioBarPropertiesPanel } from './RatioBarPropertiesPanel';

export class RatioBar implements VisualizationTypeStrategy {
  public getEditableComponent(): EditableComponent {
    return {
      visualizationType: VisualizationType.RATIO_BAR,
      name: 'editable:RatioBar',
      displayName: 'Ratio Bar',
      displayIcon: 'Action.Minus',
      editorTemplate: RatioBarEditor,
      propertiesPanel: RatioBarPropertiesPanel,
    };
  }
}
